module.exports = __webpack_public_path__ + "static/media/page header scenery.f3bd6bbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/page header scenery.svg
// module id = 38
// module chunks = 0